/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import {
	getFirstWkMonth,
	getLastWkMonth,
	getFirstWeekNumberYearBased,
} from './calUtil';
import { Box } from '@material-ui/core';
import styles from './renderWeeksStyle';
import { DateRangeContext } from '../../context/appcontext';
import PropTypes from 'prop-types';

function RenderWeeks({
	_month,
	cbWeekHighlight,
	calSelection,
	showWkSelection,
	showWalCal,
	minWk,
	maxWk,
}) {
	const [wmWeeks, setWmWeeks] = useState([]);
	const [actualWeeks, setActualWeeks] = useState([]);
	const classes = styles();
	const {
		flexCol,
		block,
		dayBg,
		dayHeader,
		weekBgBorderStart,
		weekBgBorderEnd,
		range,
		weekHighlight,
		weekHighlightHover,
		dftCursor,
		disabled,
		pointerCursor,
	} = classes;

	useEffect(() => {
		printWeekDays(_month);
		printActualWeek(_month);
	}, [_month]);

	const { setCalendarUpdate } = useContext(DateRangeContext);

	function printWeekDays(pMonth) {
		const currMonth = moment().clone().set('month', pMonth);
		const currYear = currMonth.year();
		const tyFirstWMWeek = getFirstWeekNumberYearBased(currYear, 1);
		const lyFirstWMWeek = getFirstWeekNumberYearBased(currYear - 1, 1);
		const firstWeekOfTheMonth = getFirstWkMonth(pMonth, currYear);
		const lastDayIndex = moment()
			.set('month', pMonth)
			.set('year', currYear)
			.endOf('month')
			.day();
		const firstDayIndex = moment()
			.set('month', pMonth)
			.set('year', currYear)
			.startOf('month')
			.day();
		const prevMonthLastWeekNumber = getLastWkMonth(pMonth - 1, currYear);
		const lastWeekOfTheMonth = getLastWkMonth(pMonth, currYear);

		const wkWeeks = [];

		if (currMonth.month() === 0) {
			let offset = 1;
			let wmWeekNumber = 1;
			if (lastDayIndex === 5) {
				wmWeekNumber = 0;
			}

			if (firstDayIndex === 6) {
				offset = 0;
			}
			if (firstWeekOfTheMonth.week() >= 52) {
				let count = 0;
				while (count <= lastWeekOfTheMonth.week() - wmWeekNumber) {
					wkWeeks.push(
						firstWeekOfTheMonth.week() - (lyFirstWMWeek.week() - 1) + count
					);
					count++;
				}
			} else {
				let count = firstWeekOfTheMonth.week();
				while (count <= lastWeekOfTheMonth.week() - wmWeekNumber) {
					wkWeeks.push(
						prevMonthLastWeekNumber.week() -
							(lyFirstWMWeek.week() - offset) +
							count
					);
					count++;
				}
			}
			if (wmWeekNumber === 1) {
				wkWeeks.push(1);
			}
		} else {
			for (
				let i = firstWeekOfTheMonth.week();
				i <= lastWeekOfTheMonth.week();
				i++
			) {
				wkWeeks.push(i - (tyFirstWMWeek.week() - 1));
			}
		}

		setWmWeeks(wkWeeks);
	}

	function printActualWeek(pMonth) {
		const currMonth = moment().set('month', pMonth);
		const currYear = currMonth.year();

		const _moment = moment().clone().set('month', pMonth).set('year', currYear);

		let startWeek = _moment.clone().startOf('month').startOf('week');
		const endWeek = _moment.clone().endOf('month').endOf('week');

		const weeks = [];
		while (startWeek.isSameOrBefore(endWeek, 'week')) {
			weeks.push(startWeek);
			startWeek = startWeek.clone().add(1, 'week');
		}

		setActualWeeks(weeks);
	}

	function addWeekStyles(pWeek) {
		if (
			pWeek.isSameOrBefore(minWk) ||
			pWeek.isAfter(maxWk) ||
			!showWkSelection
		) {
			return `${block} ${disabled} ${dftCursor} ${weekHighlight}`;
		}

		if (showWkSelection) {
			const { start, end } = calSelection;

			if (![start, end].includes(undefined)) {
				if (
					pWeek.isSameOrAfter(start, 'day') &&
					pWeek.isSameOrBefore(end, 'day')
				) {
					return `${block} ${range}`;
				}
			}
		}
		return `${block} ${weekHighlight} ${weekHighlightHover}`;
	}

	function handleWeekSelection(wk, actualWk) {
		setCalendarUpdate(true);
		if (!showWkSelection) {
			return;
		}

		if (
			actualWk.isAfter(minWk, 'week') &&
			actualWk.isSameOrBefore(maxWk, 'week')
		) {
			cbWeekHighlight(wk, actualWk);
		}
	}

	function addWkBgStyle(pWeek) {
		if (showWkSelection) {
			const { start, end } = calSelection;
			if (![start, end].includes(undefined)) {
				if (pWeek.startOf('week').isSame(start)) {
					return `${dayBg} ${weekBgBorderStart} ${pointerCursor}`;
				}
				if (pWeek.endOf('week').isSame(end)) {
					return `${dayBg} ${weekBgBorderEnd} ${pointerCursor}`;
				}
			}
		}
		return `${weekHighlight} ${pointerCursor}`;
	}

	if (!showWalCal) {
		return (
			<Box id="standard-calendar" className={flexCol}>
				<Box className={dayHeader}>WK</Box>
				{actualWeeks.map((wk, index) => {
					return (
						<Box className={addWkBgStyle(actualWeeks[index])} key={index}>
							<Box
								id={`week-${wk.week()}`}
								data-testId={`week-${wk}`}
								key={index}
								className={addWeekStyles(actualWeeks[index])}
								onClick={() =>
									handleWeekSelection(wk.week(), actualWeeks[index])
								}>
								{wk.week()}
							</Box>
						</Box>
					);
				})}
			</Box>
		);
	}

	return (
		<Box id="walmart-calendar" className={flexCol}>
			<Box className={dayHeader}>{'WK'}</Box>
			{wmWeeks.map((wk, index) => {
				return (
					<Box className={addWkBgStyle(actualWeeks[index])} key={index}>
						<Box
							id={`week-${wk}`}
							key={index}
							data-testId={`week-${wk}`}
							className={addWeekStyles(actualWeeks[index])}
							onClick={() => handleWeekSelection(wk, actualWeeks[index])}>
							{wk}
						</Box>
					</Box>
				);
			})}
		</Box>
	);
}

RenderWeeks.propTypes = {
	_month: PropTypes.number,
	cbWeekHighlight: PropTypes.func,
	calSelection: PropTypes.object,
	showWkSelection: PropTypes.bool,
	showWalCal: PropTypes.bool,
	minWk: PropTypes.object,
	maxWk: PropTypes.object,
};

export default RenderWeeks;
